import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

// styles
import colors from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";
import { bold } from "core/fontStyles";
const MenuTitleStyled = styled.div`
    ${bold}
    text-align: left;
    height: ${convertPxToRem(88)};
    padding: ${convertPxToRem(12)} ${convertPxToRem(16)};
    background-color: ${colors.primary.diamond};
    font-size: ${convertPxToRem(15)};
    color: ${colors.secondary.orca};

    display: flex;
    align-items: flex-end;
`;

// component
const MenuTitle = ({ title }) => {
    return <MenuTitleStyled>{title}</MenuTitleStyled>;
};

export default MenuTitle;

// prop-types
MenuTitle.propTypes = {
    title: PropTypes.string.isRequired
};
